var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1189,
    height: 1189,
    viewBox: "0 0 602 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.014 36.5C447.116 36.5 565.5 154.911 565.5 301.014C565.5 447.088 447.06 565.5 301.014 565.5C154.967 565.5 36.5 447.088 36.5 301.014C36.5002 154.939 154.911 36.5002 301.014 36.5Z",
    fill: "url(#paint0_radial_5014_75732)",
    stroke: "url(#paint1_linear_5014_75732)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.142 482.746L301.003 301L47.1035 377.157C59.0746 417.151 80.2282 453.145 108.142 482.746Z",
    fill: "url(#paint2_linear_5014_75732)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300.975 566.001C321.96 566.001 342.381 563.551 361.957 558.932L300.975 301L239.993 558.932C259.569 563.551 279.991 566.001 301.003 566.001H300.975Z",
    fill: "url(#paint3_linear_5014_75732)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M554.875 377.157L300.976 301L493.808 482.746C521.722 453.145 542.876 417.151 554.847 377.157H554.875Z",
    fill: "url(#paint4_linear_5014_75732)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M493.834 119.281L301.001 301.028L554.9 224.87C542.929 184.877 521.776 148.882 493.862 119.281H493.834Z",
    fill: "url(#paint5_linear_5014_75732)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0752 224.87L300.974 301.028L108.114 119.281C80.1998 148.882 59.0463 184.877 47.0752 224.87Z",
    fill: "url(#paint6_linear_5014_75732)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.974 36.0273C279.989 36.0273 259.568 38.4777 239.964 43.0967L300.946 301.028L361.928 43.0967C342.352 38.4777 321.93 36.0273 300.946 36.0273H300.974Z",
    fill: "url(#paint7_linear_5014_75732)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5014_75732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(300.986 301.014) scale(282.336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#040821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#081036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0A1D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#082140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#082748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5014_75732",
    x1: 301,
    y1: 36,
    x2: 301,
    y2: 566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#099BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5014_75732",
    x1: 288.75,
    y1: 329.925,
    x2: -56.2668,
    y2: 674.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#099BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5014_75732",
    x1: 356.071,
    y1: 343.175,
    x2: 57.0361,
    y2: 441.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#099BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5014_75732",
    x1: 542.622,
    y1: 329.925,
    x2: 197.605,
    y2: 674.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#099BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5014_75732",
    x1: 542.647,
    y1: 148.206,
    x2: 197.631,
    y2: 493.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#099BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5014_75732",
    x1: 288.722,
    y1: 148.206,
    x2: -56.2951,
    y2: 493.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#099BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5014_75732",
    x1: 356.042,
    y1: 78.2025,
    x2: 57.0068,
    y2: 176.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#099BFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyWheel);
export default __webpack_public_path__ + "static/media/daily-wheel.c33ac6cd209af8d349e4b07096578053.svg";
export { ForwardRef as ReactComponent };